import React, { Component } from 'react'
import { Route } from 'react-router-dom'
import axios from 'axios';
import Modal from 'react-modal';
import {NotificationContainer, NotificationManager} from 'react-notifications';
// custom
import Header from './components/Header'
import AsideLeft from './components/AsideLeft'
import AsideRight from './components/AsideRight'
import AsideMedium from './components/AsideMedium'
import Button from './components/Button';
import server from './server'
// pages
import Home from './pages/Home'
import Article from './pages/Article'
import Catalog from './pages/Catalog'
import Login from './pages/Login'
import Infobase from './pages/Infobase'
import Cabinet from './pages/Cabinet'
import './App.css'

class App extends Component {

  state = {

    loading: false,
    url: '',
    user: localStorage.user && JSON.parse(localStorage.user),

    phone: "",
    phoneHref: "",
    phone2: "",
    phone2Href: "",
    address: "",
    basesite: "",

    emails: [],
    menu: [],
    asidemenu: [],
    asidemenuOpen: "",

    form: {
      message: "",
      email: "",
    },
    formLogin: {
      email: "",
      password: "",
    },
    formLoginError: {},
    formLoginLoading: false,

    card: {
      items: []
    },

    modalInfo: false,
  }

  componentWillMount = () => {
    const token = this.state.user ? '?token='+this.state.user.token : '';

    fetch(server.uri+'base'+token, server.params)
      .then(response => response.json())
      .then(data => {
        const keys = [ 'address', 'asidemenu', 'basesite', 'direction', 'emails', 'history', 'image', 'imagexs', 'menu', 'phone', 'phoneHref', 'phone2', 'phone2Hreaf', 'usertoken', 'licenses', 'portal_link' ];

        for( let i=0; i < keys.length; i++ ) {
          let key = keys[i];
          if( data[key] !== undefined )
            this.setState({ [key]: data[key] && data[key] });
        }

        if( data.licenses === false && localStorage.user !== undefined ) {
          localStorage.removeItem('user');
          this.setState({ user: false });
        }
      });

    window.onresize = this.handleWindowResize;
    this.handleWindowResize();
  }
  componentWillUpdate = () => {
    const url = window.location.href,
      urlPrev = this.state.url;

    if( url !== urlPrev ) {
      this.handleAsideToggle(false);
      this.setState({ url: url });
    }
  }

  handleWindowResize = () => {
    const width = document.body.clientWidth,
      sizes = [
        [ 'xs', 0, 767 ],
        [ 'sm', 768, 991 ],
        [ 'md', 992, 1199 ],
        [ 'lg', 1200, 1919 ],
        [ 'xl', 1920 ],
      ];

    for( let i=0; i < sizes.length; i++ ) {
      const size = sizes[i];

      if( size[1] <= width && ( width <= size[2] || size[2] === undefined ) ) {
        this.setWidth(size);
        break;
      }
    }
  }
  setWidth = size => {
    if( this.state.width === undefined || this.state.width[0] !== size[0] )
      this.setState({ width: size });
  }

  handleFormChange = (e) => {

    const form = this.state.form,
      t = e.target;

    form[t.name] = t.value;

    this.setState({
      form: form
    });
  }

  handleAsideMenuToggle(v) {
    this.setState({
      asidemenu: Object.assign( this.state.asidemenu, { open: v } )
    });
  }
  handleLoading = (v) => {
    this.setState({ loading: v });
  }

  handleLoginChange = (e) => {
    const t = e.target;
    this.setState({
      form: Object.assign(this.state.formLogin, { [t.name]: t.value })
    });
  }
  handleLoginSubmit = (e, data) => {
    e.preventDefault();

    const form = data !== undefined ? data : this.state.formLogin,
      queryData = new FormData(),
      formError = { email: true, password: true };

    queryData.append('email', form.email);
    queryData.append('password', form.password);

    form.password = '';

    this.setState({ formLoginLoading: true });
    
    axios.post(server.uri+'login', queryData)
      .then(response => {
        const data = response.data,
          user = data.user && data.user;

        // this.setState({
        //   user: user,
        //   formLoginLoading: false,
        //   formLoginError: user ? {} : formError
        // });

        if( user ) {
          localStorage.setItem('user', JSON.stringify(user));
          window.location.reload();
        }
      })
      .catch(() => {
        NotificationManager.error('Не верный логин или праоль', 'Ошибка');
        this.setState({
          formLoginLoading: false,
          formLoginError: formError
        });
      });
  }

  handleSignout = e => {
    if( e.preventDefault !== undefined )
      e.preventDefault();

    this.setState({ user: false });
    localStorage.removeItem('user');
    window.location.reload();
  }

  // dom
  domAddClass = (dom, css) => {
    let domClasses = dom.className.split(' ');
    if( domClasses.indexOf(css) !== -1 ) return dom;

    domClasses.push(css);
    dom.className = domClasses.join(' ').replace(/\s{2,}/, ' ').replace(/^\s|\s$/, '');
  }
  domRemoveClass = (dom, css) => {
    let domClasses = dom.className.split(' ');

    while( domClasses.indexOf(css) !== -1 )
      domClasses.splice( domClasses.indexOf(css), 1 );

    dom.className = domClasses.join(' ').replace(/\s{2,}/, ' ').replace(/^\s|\s$/, '');
  }
  domToggleClass = (dom, css) => {
    const domClasses = dom.className.split(' ');
    
    if( domClasses.indexOf(css) > -1 ) this.domRemoveClass(dom, css);
    else this.domAddClass(dom, css);
  }

  // card
  handleCardAdd = item => {
    const card = this.state.card;

    card.items.push(item);
    this.setState({
      card: card
    });
  }
  handleGetCardItemIndex = item => {
    var index = -1;
    
    this.state.card.items.forEach((cardItem, i) => {
      if( cardItem.id === item.id ) {
        index = i;
        return 0;
      }
    });

    return index;
  }
  handleCardRemove = item => {
    const card = this.state.card,
      index = this.handleGetCardItemIndex(item);

    if( index > -1 )
      card.items.splice(index, 1);

    this.setState({
      card: card
    });
  }

  // modal info
  handleGetModalInfo = uri => {

    this.setState({ modalInfo: true });

    fetch(server.uri+'page/'+uri, server.params)
      .then(response => response.json())
      .then(data =>
        this.setState({ modalInfo: data })
      );
  }
  handleModalInfoClose = () => {
    this.setState({ modalInfo: false });
  }

  // notify
  handleNotify = obj => {
    const text = obj.text;

    switch( obj.type ) {
      case 'success': NotificationManager.success(text, 'закрыть', 3000); break;
      case 'error': NotificationManager.error(text, 'закрыть', 3000); break;
      default: break;
    }
  }

  // aside
  handleAsideToggle = (key) => {
    const css = 'nav--active';

    if( typeof(key) === 'object' )
      this.domToggleClass(document.body, css);
    if( key === true )
      this.domAddClass(document.body, css);
    if( key === false )
      this.domRemoveClass(document.body, css);
  }
  
  render() {

    const loginSettings = {
        formLoginLoading: this.state.formLoginLoading,
        handleLoginSubmit: this.handleLoginSubmit,
        handleSignout: this.handleSignout,
        user: this.state.user,
      },
      asideSettings = {
        user: this.state.user,
        width: this.state.width,
        handleNotify: this.handleNotify,
      },
      asideLeftSettings = {
        address: this.state.address,
        phone: this.state.phone,
        phoneHref: this.state.phoneHref,
        emails: this.state.emails,
        menu: this.state.menu,
        licenses: this.state.licenses,
        basesite: this.state.basesite,

        ...asideSettings,
      },
      asideRightSettings = {
        phone2: this.state.phone2,
        phone2Href: this.state.phone2Href,
        card: this.state.card,
        portal_link: this.state.portal_link,

        handleCardRemove: this.handleCardRemove,

        ...loginSettings,
        ...asideSettings,
      },
      asideMedium = {
        width: this.state.width,
        menu: this.state.menu,
        user: this.state.user,
        licenses: this.state.licenses,

        address: this.state.address,
        phone: this.state.phone,
        phoneHref: this.state.phoneHref,
        emails: this.state.emails,
        basesite: this.state.basesite,

        handleSignout: this.handleSignout,
        handleAsideToggle: this.handleAsideToggle,
      },
      catalogSettings = {
        handleGetCardItemIndex: this.handleGetCardItemIndex,
        handleCardAdd: this.handleCardAdd,
        handleCardRemove: this.handleCardRemove,
        handleGetModalInfo: this.handleGetModalInfo
      },
      modalInfo = this.state.modalInfo,
      cabinetSettings = {
        user: this.state.user
      };

    return (
      <div>

        <div className="app__bg img_bg" style={{ backgroundImage: `url('/assets/imgs/bg.jpg')` }}></div>

        <button className="nav__btn hidden-md-up" onClick={ this.handleAsideToggle }></button>
        <Header menu={ this.state.menu }/>
        <AsideMedium {...asideMedium}/>

        <section className="page-body">
          <div className="container">

            <AsideLeft {...asideLeftSettings}/>

            <main>

              <div className={'loading'+( !this.state.loading ? ' hide' : '' )}></div>

              {/* home */}
              <Route exact path="/" component={ () => <Home/> }/>

              {/* Aboutus */}
              <Route exact path="/aboutus.html" render={ route => <Article route={route}/> } />
              <Route exact path="/contacts.html" render={ route => <Article route={route}/> } />

              {/* catalog */}
              <Route path="/catalog" component={ route => <Catalog route={route} {...catalogSettings}/> }/>

              {/* infobase */}
              <Route path="/infobase" render={ () => <Infobase user={ this.state.user } handleGetModalInfo={ this.handleGetModalInfo }/> }/>

              {/* login & cabinet */}
              <Route path="/login" render={ () => <Login {...loginSettings}/> } />
              <Route path="/cabinet" component={ route => <Cabinet route={route} {...cabinetSettings}/> } />

              {/* contacts */}
              {/* <Route exact path="/contacts" component={ () => <Contacts /> } /> */}
            </main>

            <AsideRight {...asideRightSettings}/>
          </div>
        </section>

        <footer className="page-footer"></footer>

        <Modal className="modal__product" isOpen={modalInfo!==false} onRequestClose={ this.handleModalInfoClose }>
          <div className={'modal__laoding loading'+( modalInfo.pagetitle ? ' hide' : '' )}></div>
          <article className={!modalInfo.pagetitle ? 'hide' : ''}>
            <header className="modal__header">

              <Button theme="remove" class="modal__close" handleClick={ this.handleModalInfoClose }></Button>
            
              <h2 className="page__title">
                <span>{modalInfo.pagetitle}</span>
              </h2>
              <div className="table">
                <ul>
                  <li valign="top">
                    <h3 className="table__title">{modalInfo.publishedon}</h3>
                    <p className="table__longtitle">{modalInfo.longtitle}</p>
                    <p className="table__description">{modalInfo.introtext}</p>

                    <p className={'table__link'+( !modalInfo.document ? ' hide' : '' )}>
                      <a href={'/'+modalInfo.document} target="_blank" rel="noopener noreferrer">
                        <i className="ico_arrow ico_arrow_success ico_arrow_small ico_arrow_middle"></i>
                        <span>{modalInfo.introtext}</span>
                      </a>
                    </p>
                  </li>
                </ul>
              </div>
            </header>

            <section className="modal__body" dangerouslySetInnerHTML={{ __html: modalInfo.content }}></section>
          </article>
        </Modal>        

        <NotificationContainer/>
      </div>
    );
  }
}
export default App;
